import React from 'react'
import DocumentTitle from 'react-document-title'

interface IProps {
  children: string
}

export const PageTitle: React.SFC<IProps> = ({ children }) => (
  <>
    <DocumentTitle title={`${children} :: Shopify Gateway Manager`} />
    {children}
  </>
)
